import i18next from 'i18next';
import { DOC_TYPE_AADE_CODE } from '../../interfaces/documentType.interface';
import {
  SORT_BY_CUSTOMERS,
  SORT_BY_MONEY_COLLECTION,
  SORT_BY_PRODUCTS,
  SORT_BY_SALES,
} from '../../interfaces/enumerables';
import { SortBy } from '../../interfaces/forms.interface';

export const getProductsSortByFilter: () => { [key in SORT_BY_PRODUCTS]: SortBy } = () => {
  return {
    [SORT_BY_PRODUCTS.NAME]: { value: SORT_BY_PRODUCTS.NAME, label: i18next.t('FILTERS.NAME') },
    [SORT_BY_PRODUCTS.INTERNAL_ID]: { value: SORT_BY_PRODUCTS.INTERNAL_ID, label: i18next.t('FILTERS.INTERNAL_ID') },
    [SORT_BY_PRODUCTS.INTERNAL_SERIAL]: {
      value: SORT_BY_PRODUCTS.INTERNAL_SERIAL,
      label: i18next.t('FILTERS.INTERNAL_SERIAL'),
    },
    [SORT_BY_PRODUCTS.CREATED_AT]: { value: SORT_BY_PRODUCTS.CREATED_AT, label: i18next.t('FILTERS.CREATED_AT') },
  };
};

export const getCustomersSortByFilter: (showSubtotals?: boolean) => { [key in SORT_BY_CUSTOMERS]: SortBy } = (
  showSubtotals?: boolean,
) => {
  // @ts-expect-error to be solved
  const data: { [key in SORT_BY_CUSTOMERS]: SortBy } = {
    [SORT_BY_CUSTOMERS.COMPANY_NAME]: {
      value: SORT_BY_CUSTOMERS.COMPANY_NAME,
      label: i18next.t('FILTERS.COMPANY_NAME'),
    },
    [SORT_BY_CUSTOMERS.VAT_NUMBER]: { value: SORT_BY_CUSTOMERS.VAT_NUMBER, label: i18next.t('FILTERS.VAT_NUMBER') },
    [SORT_BY_CUSTOMERS.CREATED_AT]: { value: SORT_BY_CUSTOMERS.CREATED_AT, label: i18next.t('FILTERS.CREATED_AT') },
  };

  if (showSubtotals) {
    data[SORT_BY_CUSTOMERS.CUSTOMER_SUBTOTAL] = {
      value: SORT_BY_CUSTOMERS.CUSTOMER_SUBTOTAL,
      label: i18next.t('FILTERS.CUSTOMER_SUBTOTAL'),
    };
    data[SORT_BY_CUSTOMERS.SUPPLIER_SUBTOTAL] = {
      value: SORT_BY_CUSTOMERS.SUPPLIER_SUBTOTAL,
      label: i18next.t('FILTERS.SUPPLIER_SUBTOTAL'),
    };
  }

  return data;
};

export const getSalesSortByFilter: () => { [key in SORT_BY_SALES]: SortBy } = () => {
  return {
    [SORT_BY_SALES.SERIES_NAME]: { value: SORT_BY_SALES.SERIES_NAME, label: i18next.t('FILTERS.SERIES_NAME') },
    [SORT_BY_SALES.SERIAL_NUMBER]: { value: SORT_BY_SALES.SERIAL_NUMBER, label: i18next.t('FILTERS.SERIAL_NUMBER') },
    [SORT_BY_SALES.YEAR]: { value: SORT_BY_SALES.YEAR, label: i18next.t('FILTERS.YEAR') },
    [SORT_BY_SALES.SENT_TO_AADE_AT]: { value: SORT_BY_SALES.SENT_TO_AADE_AT, label: i18next.t('FILTERS.SENT_TO_AADE') },
    [SORT_BY_SALES.CUSTOMER]: { value: SORT_BY_SALES.CUSTOMER, label: i18next.t('FILTERS.CUSTOMER') },
    [SORT_BY_SALES.PAYMENT_TYPE]: { value: SORT_BY_SALES.PAYMENT_TYPE, label: i18next.t('FILTERS.PAYMENT_TYPE') },
    [SORT_BY_SALES.DOCUMENT_TYPE]: { value: SORT_BY_SALES.DOCUMENT_TYPE, label: i18next.t('FILTERS.DOCUMENT_TYPE') },
    [SORT_BY_SALES.TOTAL_VALUE]: { value: SORT_BY_SALES.TOTAL_VALUE, label: i18next.t('FILTERS.TOTAL_VALUE') },
    [SORT_BY_SALES.CREATED_AT]: { value: SORT_BY_SALES.CREATED_AT, label: i18next.t('FILTERS.CREATED_AT') },
  };
};

export const getMoneyCollectionByFilter: () => { [key in SORT_BY_MONEY_COLLECTION]: SortBy } = () => {
  return {
    [SORT_BY_MONEY_COLLECTION.CREATED_AT]: {
      value: SORT_BY_MONEY_COLLECTION.CREATED_AT,
      label: i18next.t('FILTERS.CREATED_AT'),
    },
  };
};

export const getSalesTypeSelectionFilter: () => { [key: string]: { value: string | null; label: string } } = () => {
  return {
    ['ALL']: {
      value: 'ALL',
      label: i18next.t('DOC_TYPES.ALL'),
    },
    [DOC_TYPE_AADE_CODE.PRO_FORMA_INVOICE]: {
      value: DOC_TYPE_AADE_CODE.PRO_FORMA_INVOICE,
      label: i18next.t('DOC_TYPES.PRO_FORMA_INVOICE'),
    },
    // [DOC_TYPE_AADE_CODE.RECEIPT]: {
    //   value: DOC_TYPE_AADE_CODE.RECEIPT,
    //   label: i18next.t('DOC_TYPES.RECEIPT'),
    // },
    [DOC_TYPE_AADE_CODE.INVOICE]: {
      value: DOC_TYPE_AADE_CODE.INVOICE,
      label: i18next.t('DOC_TYPES.INVOICE'),
    },
    [DOC_TYPE_AADE_CODE.INVOICE_INTRA_COMMUNITY_DELIVERIES]: {
      value: DOC_TYPE_AADE_CODE.INVOICE_INTRA_COMMUNITY_DELIVERIES,
      label: i18next.t('DOC_TYPES.INVOICE_INTRA_COMMUNITY_DELIVERIES'),
    },
    [DOC_TYPE_AADE_CODE.INVOICE_THIRD_COUNTRIES_DELIVERIES]: {
      value: DOC_TYPE_AADE_CODE.INVOICE_THIRD_COUNTRIES_DELIVERIES,
      label: i18next.t('DOC_TYPES.INVOICE_THIRD_COUNTRIES_DELIVERIES'),
    },
    [DOC_TYPE_AADE_CODE.INVOICE_SERVICES]: {
      value: DOC_TYPE_AADE_CODE.INVOICE_SERVICES,
      label: i18next.t('DOC_TYPES.INVOICE_SERVICES'),
    },
    [DOC_TYPE_AADE_CODE.INVOICE_SERVICES_INTRA_COMMUNITY]: {
      value: DOC_TYPE_AADE_CODE.INVOICE_SERVICES_INTRA_COMMUNITY,
      label: i18next.t('DOC_TYPES.INVOICE_SERVICES_INTRA_COMMUNITY'),
    },
    [DOC_TYPE_AADE_CODE.INVOICE_SERVICES_THIRD_COUNTRIES]: {
      value: DOC_TYPE_AADE_CODE.INVOICE_SERVICES_THIRD_COUNTRIES,
      label: i18next.t('DOC_TYPES.INVOICE_SERVICES_THIRD_COUNTRIES'),
    },
    [DOC_TYPE_AADE_CODE.INVOICE_RETURN_RELATED]: {
      value: DOC_TYPE_AADE_CODE.INVOICE_RETURN_RELATED,
      label: i18next.t('DOC_TYPES.INVOICE_RETURN_RELATED'),
    },
    [DOC_TYPE_AADE_CODE.INVOICE_RETURN_UNRELATED]: {
      value: DOC_TYPE_AADE_CODE.INVOICE_RETURN_UNRELATED,
      label: i18next.t('DOC_TYPES.INVOICE_RETURN_UNRELATED'),
    },
    // [DOC_TYPE_AADE_CODE.INVOICE_RETURN_CREDIT_UNRELATED]: {
    //   value: DOC_TYPE_AADE_CODE.INVOICE_RETURN_CREDIT_UNRELATED,
    //   label: i18next.t('DOC_TYPES.INVOICE_RETURN_CREDIT_UNRELATED'),
    // },
    [DOC_TYPE_AADE_CODE.SELF_DELIVERY_ITEM]: {
      value: DOC_TYPE_AADE_CODE.SELF_DELIVERY_ITEM,
      label: i18next.t('DOC_TYPES.SELF_DELIVERY_ITEM'),
    },
    [DOC_TYPE_AADE_CODE.SELF_USE_ITEM]: {
      value: DOC_TYPE_AADE_CODE.SELF_USE_ITEM,
      label: i18next.t('DOC_TYPES.SELF_USE_ITEM'),
    },
    [DOC_TYPE_AADE_CODE.DELIVERY_NOTE]: {
      value: DOC_TYPE_AADE_CODE.DELIVERY_NOTE,
      label: i18next.t('DOC_TYPES.DELIVERY_NOTE'),
    },
    [DOC_TYPE_AADE_CODE.INVERTED_DELIVERY_NOTE]: {
      value: DOC_TYPE_AADE_CODE.INVERTED_DELIVERY_NOTE,
      label: i18next.t('DOC_TYPES.INVERTED_DELIVERY_NOTE'),
    },
    [DOC_TYPE_AADE_CODE.RECEIPT_SERVICES]: {
      value: DOC_TYPE_AADE_CODE.RECEIPT_SERVICES,
      label: i18next.t('DOC_TYPES.RECEIPT_SERVICES'),
    },
    [DOC_TYPE_AADE_CODE.QUANTITY_RECEIPT_FORM]: {
      value: DOC_TYPE_AADE_CODE.QUANTITY_RECEIPT_FORM,
      label: i18next.t('DOC_TYPES.QUANTITY_RECEIPT_FORM'),
    },
  };
};
